import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-location-plams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-location-plams.component.scss?ngResource";
import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { MapService } from "../../../../map/shared/map.service";
import { FormControl, FormGroup } from "@angular/forms";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { ApiProxyConstants } from "../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../app.config";
import { AppRoutingConstants } from "../../../../app-routing.constants";
import { UrlConstants } from "../../../../shared/constants/url.constants";
import { WktConverterUtils } from "../../../../shared/utils/wkt-converter-utils";
import * as JsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { ViewApplicationLocationPlamsConstants } from "./view-application-location-plams.constants";
import { ApplicationViewService } from "../../../shared/application-view.service";
import { ViewApplicationBaseComponent } from "../../../shared/view-application-base/view-application-base.component";
import { RouterParamsService } from "../../../../shared/services/route-params.service";
import { AutoUnsubPortal } from "../../../../shared/decorators/autounsub-portal.decorator";
let ViewApplicationLocationPlamsComponent = class ViewApplicationLocationPlamsComponent extends ViewApplicationBaseComponent {
    applicationViewService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appController;
    mapService;
    changeDetectorRefs;
    routerParamsService;
    active;
    propertiesForm;
    descriptionLabel1 = ViewApplicationLocationPlamsConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = ViewApplicationLocationPlamsConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = ViewApplicationLocationPlamsConstants.DESCRIPTION_LABEL_3;
    descriptionLabel4 = ViewApplicationLocationPlamsConstants.DESCRIPTION_LABEL_4;
    descriptionLabel5 = ViewApplicationLocationPlamsConstants.DESCRIPTION_LABEL_5;
    applicationControl = ViewApplicationLocationPlamsConstants.APPLICATION_TYPE_CONTROL;
    erfNoControl = ViewApplicationLocationPlamsConstants.ERF_NO_CONTROL;
    subdivisionControl = ViewApplicationLocationPlamsConstants.SUBDIVISION_CONTROL;
    allotmentControl = ViewApplicationLocationPlamsConstants.ALLOTMENT_CONTROL;
    farmNoControl = ViewApplicationLocationPlamsConstants.FARM_NO_CONTROL;
    zoningControl = ViewApplicationLocationPlamsConstants.ZONING_CONTROL;
    streetNumberControl = ViewApplicationLocationPlamsConstants.STREET_NO_CONTROL;
    streetNameControl = ViewApplicationLocationPlamsConstants.STREET_NAME_CONTROL;
    townControl = ViewApplicationLocationPlamsConstants.TOWN_CONTROL;
    sgCodeControl = ViewApplicationLocationPlamsConstants.SG_CODE_CONTROL;
    addressControl = ViewApplicationLocationPlamsConstants.ADDRESS_CONTROL;
    ownerControl = ViewApplicationLocationPlamsConstants.OWNER_CONTROL;
    applicationSelectLabel = ViewApplicationLocationPlamsConstants.APPLICATION_TYPE_PLACEHOLDER;
    dropdownApplicationPlaceholder = ViewApplicationLocationPlamsConstants.APPLICATION_TYPE_PLACEHOLDER;
    erfNoTextPlaceHolder = ViewApplicationLocationPlamsConstants.ERF_NO_TEXT_PLACEHOLDER;
    subdivisionTextPlaceHolder = ViewApplicationLocationPlamsConstants.SUBDIVISION_TEXT_PLACEHOLDER;
    allotmentTextPlaceHolder = ViewApplicationLocationPlamsConstants.ALLOTMENT_TEXT_PLACEHOLDER;
    farmNoTextPlaceHolder = ViewApplicationLocationPlamsConstants.FARM_NO_TEXT_PLACEHOLDER;
    zoningControlTextPlaceHolder = ViewApplicationLocationPlamsConstants.ZONING_TEXT_PLACEHOLDER;
    streetNumberTextPlaceHolder = ViewApplicationLocationPlamsConstants.STREET_NO_TEXT_PLACEHOLDER;
    streetNameTextPlaceHolder = ViewApplicationLocationPlamsConstants.STREET_NAME_TEXT_PLACEHOLDER;
    townTextPlaceHolder = ViewApplicationLocationPlamsConstants.TOWN_TEXT_PLACEHOLDER;
    sgCodeTextPlaceHolder = ViewApplicationLocationPlamsConstants.SG_CODE_TEXT_PLACEHOLDER;
    addressTextPlaceHolder = ViewApplicationLocationPlamsConstants.ADDRESS_TEXT_PLACEHOLDER;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    removeLabel = SharedConstants.REMOVE_LABEL;
    removePropertyLabel = ViewApplicationLocationPlamsConstants.REMOVE_PROPERTY_LABEL;
    ownerLabel = ViewApplicationLocationPlamsConstants.OWNER_LABEL;
    layerReference = ViewApplicationLocationPlamsConstants.LAYER_REF;
    ownerDisableFilterBy = true;
    ownerDisableAdd = true;
    ownerDisableDelete = true;
    ownerDisableEditing = true;
    ownerGroups = [];
    ownerShowGroupsDropdown = true;
    ownerListLabel = "Owner";
    appTypes = [];
    applicant;
    fullApplicationCheckRequired = false;
    ownerMetaData;
    showOnlyPropertyAndZoningLayers = true;
    existingApplication = false;
    mapComponent;
    isMapLoaded = false;
    leaseGraphic = null;
    hasLoadedLookups = false;
    hasLoadedApplicationProperties = false;
    selectedApplicationType = null;
    application;
    applicationLoaded = false;
    getTrueCentroidSubscription;
    selectedApplicationSubscription;
    getLookupsObservableSubscription;
    constructor(applicationViewService, aflaModuleStrategyService, selectedApplicationService, appController, mapService, changeDetectorRefs, routerParamsService) {
        super(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService);
        this.applicationViewService = applicationViewService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appController = appController;
        this.mapService = mapService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.routerParamsService = routerParamsService;
        this.getMetadata();
        this.initForm();
    }
    ngOnInit() {
        this.getLookups();
        this.listenForRouteParamChange();
    }
    handleRouteChange() {
    }
    ngAfterViewInit() {
        this.mapService.actionPropertyEnabled = false;
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
    }
    ngOnDestroy() {
        this.mapService.actionPropertyEnabled = false;
    }
    loadMetadata(stepMeta) {
        this.ownerGroups = stepMeta.ownerGroup;
        this.ownerGroups[0].requiredFields = stepMeta.requiredFields;
        this.listenForSelectedApplication();
    }
    getProperties() {
        if (this.propertiesForm) {
            return this.propertiesForm.get("properties");
        }
    }
    setTrueCentroid(geometryArc, newPropertyFormGroup, propertyControl) {
        const proxyUrl = ApiProxyConstants.URL;
        const gpToolUrl = AppConfig.settings.arcGIS.servicesURL + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
        const url = `${proxyUrl}?${gpToolUrl}`;
        const formData = new FormData();
        formData.append("f", "json");
        formData.append("geometryJSON", JSON.stringify(geometryArc));
        this.getTrueCentroidSubscription = this.applicationViewService.getTrueCentroid(url, formData).subscribe({
            next: (response) => {
                newPropertyFormGroup.get("centroid").setValue(response.results[0].value);
                propertyControl.push(newPropertyFormGroup);
                this.active = propertyControl.length - 1;
                this.disablePropertyControls(propertyControl.length - 1);
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationLocationPlamsConstants.TRUE_CENTROID, error, CRUDOperation.Get);
            }
        });
    }
    disablePropertyControls(propertyIndex) {
        const propertyControl = this.getProperties().controls[propertyIndex];
        propertyControl.get(this.erfNoControl).disable();
        propertyControl.get(this.subdivisionControl).disable();
        propertyControl.get(this.zoningControl).disable();
        propertyControl.get(this.streetNameControl).disable();
        propertyControl.get(this.streetNumberControl).disable();
        propertyControl.get(this.townControl).disable();
        propertyControl.get(this.allotmentControl).disable();
        propertyControl.get(this.sgCodeControl).disable();
        propertyControl.get(this.addressControl).disable();
        propertyControl.get(this.erfNoControl).disable();
    }
    listenForSelectedApplication() {
        this.selectedApplicationSubscription = this.selectedApplicationService.$selectedApplication.subscribe({
            next: (application) => {
                if (application && application.id >= 0 && !this.applicationLoaded) {
                    this.application = application;
                    this.setApplicationData();
                    this.applicationLoaded = true;
                }
            }
        });
    }
    setApplicationData() {
        if (this.application && this.application.properties && this.application.properties.length > 0) {
            const applicationType = this.selectedApplication.applicationType;
            this.appTypes.forEach(item => {
                if (item.value === applicationType) {
                    this.propertiesForm.get(this.applicationControl).enable();
                    this.propertiesForm.get(this.applicationControl).setValue(item);
                    this.propertiesForm.get(this.applicationControl).disable();
                }
            });
            // TODO:: Add lease areas to the map
            if (!this.getProperties()) {
                return;
            }
            else {
                this.getProperties().clear();
                const propertyControl = this.getProperties();
                let index = 0;
                this.application.properties.forEach((property) => {
                    // create form groups for each property
                    const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(property.shape, 102100);
                    const geom = JsonUtils.fromJSON(geometryArc);
                    const newPropertyFormGroup = this.createFormGroup(property, geom);
                    this.setTrueCentroid(geometryArc, newPropertyFormGroup, propertyControl);
                    index++;
                });
                this.changeDetectorRefs.detectChanges();
            }
        }
    }
    createFormGroup(property, geom) {
        return new FormGroup({
            property: new FormControl(property),
            erfNo: new FormControl({ value: property.erfNumber, disabled: true }),
            subdivision: new FormControl({ value: property.subdivision, disabled: true }),
            allotment: new FormControl({ value: property.allotment, disabled: true }),
            farmNo: new FormControl({ value: property.farmNumber, disabled: true }),
            zoning: new FormControl({ value: property.zoning, disabled: true }),
            streetNumber: new FormControl({ value: property.streetNumber, disabled: true }),
            streetName: new FormControl({ value: property.streetName, disabled: true }),
            town: new FormControl({ value: property.town, disabled: true }),
            sgCode: new FormControl({ value: property.sgCode, disabled: true }),
            address: new FormControl({ value: property.address, disabled: true }),
            geometry: new FormControl(geom),
            centroid: new FormControl(null),
            owners: new FormControl(property.owners)
        });
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("propertiesForm");
        this.propertiesForm = form;
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.applicationViewService.moduleID} and name eq 'ApplicationType'`,
        };
        this.getLookupsObservableSubscription = this.applicationViewService
            .getLookupsObservable(params)
            .subscribe({
            next: (response) => this.onGetLookupsCompleted(response),
            error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationLocationPlamsConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const appTypes = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "ApplicationType") {
                    appTypes.push(JSON.parse(item.content));
                }
            });
        }
        this.appTypes = appTypes;
        // this.applicationCreateService.setHasLoadedLookups(true);
        this.setApplicationData();
        this.changeDetectorRefs.detectChanges();
    }
    syncMapGeometries() {
        const geometries = [];
        if (this.application.leaseAreas && this.application.leaseAreas.length > 0) {
            const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(this.application.leaseAreas[0].shape, 102100);
            const leaseGeom = JsonUtils.fromJSON(geometryArc);
            geometries.push(leaseGeom);
        }
        this.getProperties().controls.forEach(item => {
            const geom = item.get("geometry").value;
            if (geom !== null) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, "PLAMS graphics", true);
        }
    }
    static ctorParameters = () => [
        { type: ApplicationViewService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: MapService },
        { type: ChangeDetectorRef },
        { type: RouterParamsService }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
ViewApplicationLocationPlamsComponent = __decorate([
    Component({
        selector: "app-view-application-location-plams",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsubPortal()
], ViewApplicationLocationPlamsComponent);
export { ViewApplicationLocationPlamsComponent };
